import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import logo from '../assets/logo.png';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.monalerte.app';

function detectPlatform() {
  if (typeof navigator === 'undefined') return null;
  const userAgent = navigator.userAgent || '';
  const userAgentPlatform = navigator.userAgentData?.platform || '';
  const isIPadDesktopMode = /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1;
  if (/iPhone|iPad|iPod/i.test(userAgent) || isIPadDesktopMode) return 'IOS';
  if (/Android/i.test(userAgent) || /Android/i.test(userAgentPlatform)) return 'ANDROID';
  return null;
}

export default function RejoindrePage() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [platform, setPlatform] = useState(detectPlatform);
  const [consent, setConsent] = useState(false);
  const [state, setState] = useState({ loading: false, message: '', error: false });
  const isIos = platform === 'IOS';

  async function submit(event) {
    event.preventDefault();
    setState({ loading: true, message: '', error: false });
    try {
      const response = await fetch(`${API_URL}/api/beta-signups`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          platform,
          source: ['poster-men', 'poster-women'].includes(searchParams.get('source'))
            ? searchParams.get('source')
            : 'website',
          privacyConsent: consent,
        }),
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.message || 'Inscription indisponible.');
      setState({ loading: false, message: payload.message, error: false });
    } catch (error) {
      setState({ loading: false, message: error.message, error: true });
    }
  }

  return (
    <main style={{ minHeight: '100vh', padding: '36px 20px 72px', background: 'radial-gradient(circle at top, #1d3357 0%, #050b14 52%)' }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <Link to="/le-projet" style={{ color: 'var(--mga-gold)', fontWeight: 700 }}>← Découvrir MonAlerte</Link>
        <section className="glass-card" style={{ marginTop: 24, padding: 'clamp(24px, 6vw, 52px)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 28 }}>
            <img src={logo} alt="MonAlerte" style={{ width: 56, height: 56, objectFit: 'contain' }} />
            <strong style={{ fontFamily: 'var(--font-display)', fontSize: '1.4rem', color: 'white' }}>Mon<span style={{ color: 'var(--mga-gold)' }}>Alerte</span></strong>
          </div>
          <p className="badge-gold">C’est gratuit</p>
          <h1 style={{ fontSize: 'clamp(2.2rem, 8vw, 4rem)', lineHeight: 1.02, marginBottom: 18 }}>Ne rentre plus seul·e.</h1>
          <p style={{ fontSize: '1.1rem', marginBottom: 32 }}>{isIos
            ? 'Ton iPhone a été détecté. L’application est actuellement en développement : inscris-toi sur la liste d’attente et reçois gratuitement ton invitation dès que la bêta iPhone est disponible.'
            : platform === 'ANDROID'
              ? 'Ton Android a été détecté. Rejoins la bêta avec les personnes qui veillent sur toi : tu recevras prochainement ton lien d’invitation gratuit par e-mail.'
              : 'Choisis ton appareil pour rejoindre gratuitement la bêta MonAlerte.'}
          </p>
          <form onSubmit={submit}>
            <p style={{ color: 'var(--mga-slate-300)', marginBottom: 24 }}>Envie de découvrir MonAlerte dans sa globalité ? <Link to="/le-projet" style={{ fontWeight: 700 }}>Découvrir le projet →</Link></p>
            <label htmlFor="email" style={{ display: 'block', fontWeight: 700, color: 'white', marginBottom: 8 }}>Ton adresse e-mail</label>
            <input id="email" type="email" autoComplete="email" required value={email} onChange={event => setEmail(event.target.value)} placeholder="toi@exemple.fr" style={{ width: '100%', boxSizing: 'border-box', padding: 16, borderRadius: 12, border: '1px solid rgba(255,255,255,.25)', fontSize: '1rem', marginBottom: 22 }} />
            {!platform && <fieldset style={{ border: 0, padding: 0, margin: '0 0 24px' }}>
              <legend style={{ color: 'white', fontWeight: 700, marginBottom: 10 }}>Tu utilises</legend>
              {['ANDROID', 'IOS'].map(value => <label key={value} style={{ display: 'block', padding: '13px 14px', marginBottom: 10, border: `1px solid ${platform === value ? 'var(--mga-gold)' : 'rgba(255,255,255,.18)'}`, borderRadius: 12, cursor: 'pointer', color: 'white' }}><input type="radio" name="platform" value={value} checked={platform === value} onChange={() => setPlatform(value)} style={{ marginRight: 10 }} />{value === 'ANDROID' ? 'Android — recevoir une invitation bêta' : 'iPhone — rejoindre la liste d’attente'}</label>)}
            </fieldset>}
            <label style={{ display: 'flex', gap: 12, alignItems: 'flex-start', color: 'var(--mga-slate-300)', fontSize: '.9rem', marginBottom: 24, cursor: 'pointer' }}><input type="checkbox" checked={consent} onChange={event => setConsent(event.target.checked)} required style={{ width: 24, height: 24, minWidth: 24, marginTop: 1, flexShrink: 0, accentColor: 'var(--mga-gold)' }} />J’accepte que MonAlerte utilise mon e-mail pour gérer ma demande de bêta et m’envoyer les invitations associées.</label>
            <button type="submit" className="button-primary" disabled={state.loading || !consent || !platform} style={{ width: '100%', opacity: state.loading || !consent || !platform ? .5 : 1, cursor: state.loading || !consent || !platform ? 'not-allowed' : 'pointer' }}>{state.loading ? 'Inscription…' : 'Rejoindre gratuitement'}</button>
          </form>
          {state.message && <p role="status" style={{ marginTop: 22, color: state.error ? '#fca5a5' : '#86efac', fontWeight: 700 }}>{state.message}</p>}
          <p style={{ fontSize: '.82rem', marginTop: 26 }}>Tu peux demander la suppression de ton e-mail à tout moment. <Link to="/vie-privee">Vie privée</Link></p>
        </section>
      </div>
    </main>
  );
}
